import { render, staticRenderFns } from "./objection-to-procedure-or-decision-request.vue?vue&type=template&id=a02cfe44&scoped=true&"
import script from "./objection-to-procedure-or-decision-request.vue?vue&type=script&lang=js&"
export * from "./objection-to-procedure-or-decision-request.vue?vue&type=script&lang=js&"
import style0 from "./objection-to-procedure-or-decision-request.vue?vue&type=style&index=0&id=a02cfe44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02cfe44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
